import { j as o } from "./kezios-design-system.esm172.js";
import t from "./kezios-design-system.esm227.js";
const s = (i) => /* @__PURE__ */ o.jsx("img", { width: i.size, height: i.size, src: t });
export {
  s as IconDavinciResolve
};
